import { robotoCondensed } from "@/pages/_app";
import * as Dialog from "@radix-ui/react-dialog";
import React from "react";

const callAll =
  (...fns: Array<(...args: any) => any>) =>
  (...args: any) =>
    fns.forEach((fn) => fn && fn(...args));
interface ModalProps {
  children: React.ReactNode;
  open: boolean;
  setOpen: React.Dispatch<boolean>;
}
export function Modal({ children, open, setOpen }: ModalProps) {
  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className="dialog-overlay z-10" />
        <Dialog.Content
          className="dialog-content z-20"
          style={robotoCondensed.style}
        >
          <div className="relative overflow-y-scroll">{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

interface ModalTriggerButtonProps {
  children: React.ReactElement;
  setOpen: React.Dispatch<boolean>;
}
export function ModalCloseButton({
  children: child,
  setOpen,
}: ModalTriggerButtonProps) {
  return React.cloneElement(child, {
    onClick: callAll(() => setOpen(false), child.props.onClick),
  });
}
export function ModalOpenButton({
  children: child,
  setOpen,
}: ModalTriggerButtonProps) {
  return React.cloneElement(child, {
    onClick: callAll(() => setOpen(true), child.props.onClick),
  });
}
